"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _banner = require("@/api/banner/banner");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      swiperInfo: {
        id: "",
        imageUrl: "",
        linkUrl: "",
        name: ""
      },
      imageUrl: "",
      rules: {
        name: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }, {
          min: 1,
          max: 15,
          message: "标题长度推荐在 1 到 15 个字符",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.swiperInfo.imageUrl = e.ossOriUrl;
    },
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          if (_this.swiperInfo.imageUrl === "") {
            return _this.$message.error("请先上传轮播图片后,再进行提交。");
          } else {
            (0, _banner.addBanner)(_this.swiperInfo).then(function () {
              _this.$message.success("操作成功。");
              _this.$router.push("/webSet/webSet-swiper");
            });
          }
        }
      });
    },
    isBack: function isBack() {
      this.$router.push("/webSet/webSet-swiper");
    }
  },
  components: {
    FileImg: _index.default
  }
};